/* eslint
    max-classes-per-file: "warn"
*/

export class Features {
  static FeatureIsActive = (featureName: string): boolean => {
    const featureIsActiveForClient = document.querySelector('html').hasAttribute(featureName);
    return featureIsActiveForClient;
  }
}

export { FeatureNames } from './featurenames.service';
